import { defineComponent } from 'vue';
import { appPort, jumpModuleApp, iOSPort } from '@/widget/index';
import { hostPath } from '@/public/utils/basePath';
export default defineComponent({
    props: {
        item: {
            default() {
                return {};
            },
            type: Object
        },
        size: {
            default: 'normal',
            type: String
        },
        small: {
            default: false,
            type: Boolean
        },
        unlockType: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            ios: iOSPort() && appPort(),
            kw: this.$route.query.keyword || ''
        };
    },
    methods: {
        toDetial(item) {
            let url = `${hostPath}/learn/courseguide/train/${item.meetingId || item.lessonId}`;
            if (appPort()) {
                jumpModuleApp({
                    url: url,
                    typeId: 'h5'
                });
            }
            else {
                // h5 进入导览页
                this.$router.push({
                    path: `/courseguide/train/${item.meetingId || item.lessonId}`
                });
            }
        }
    }
});
